"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var IconTextBtn = function (_a) {
    var onClick = _a.onClick, img = _a.img, alt = _a.alt, text = _a.text, childClass = _a.childClass;
    return ((0, preact_1.h)("button", { onClick: onClick, class: "preact-btn icon-text-btn icon-text-btn--".concat(childClass) },
        (0, preact_1.h)("img", { src: img, alt: alt }),
        (0, preact_1.h)("span", { class: 'icon-text-btn__text' }, text)));
};
exports.default = IconTextBtn;
